const initialState = {
    isLoading: false,
    homepageContentLoaded: false,
    homepageContent: {},
    invitations: [],
    paidHits: {
        loading: false,
        data: [],
        error: null,
    },
    eventsNearMe: {
        loading: false,
        data: [],
        error: null,
    },
    localPlayers: {
        loading: false,
        data: [],
        error: null,
    },
    colleges: {
        loading: false,
        data: [],
        error: null,
    },
    highSchools: {
        loading: false,
        data: [],
        error: null,
    },
    playerCreatedPlays: {
        loading: false,
        data: [],
        error: null,
    },
    paidHitClubs: {
        loading: false,
        data: [],
        error: null,
    },
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'HOMEPAGE_CONTENT:FETCH_CONTENT_REQUEST':
            return {
                ...state,
                isLoading: true,
                homepageContentLoaded: false,
            };

        case 'HOMEPAGE_CONTENT:FETCH_CONTENT_SUCCESS':
            return {
                ...state,
                homepageContent: action.data,
                isLoading: false,
                homepageContentLoaded: true,
            };

        case 'HOMEPAGE_CONTENT:FETCH_CONTENT_FAILURE':
            return {
                ...state,
                isLoading: false,
                homepageContentLoaded: false,
            };

        case 'HOMEPAGE_CONTENT:GET_INVITATIONS_SUCCESS':
            return {
                ...state,
                invitations: action.payload.invites,
            };
        case 'HOMEPAGE_CONTENT:GET_PAID_HITS':
            return {
                ...state,
                paidHits: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_PAID_HITS_SUCCESS':
            return {
                ...state,
                paidHits: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_PAID_HITS_FAILURE':
            return {
                ...state,
                paidHits: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME':
            return {
                ...state,
                eventsNearMe: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME_SUCCESS':
            return {
                ...state,
                eventsNearMe: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_EVENTS_NEAR_ME_FAILURE':
            return {
                ...state,
                eventsNearMe: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_LOCAL_PLAYERS':
            return {
                ...state,
                localPlayers: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_LOCAL_PLAYERS_SUCCESS':
            return {
                ...state,
                localPlayers: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_LOCAL_PLAYERS_FAILURE':
            return {
                ...state,
                localPlayers: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_COLLEGES':
            return {
                ...state,
                colleges: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_COLLEGES_SUCCESS':
            return {
                ...state,
                colleges: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_COLLEGES_FAILURE':
            return {
                ...state,
                colleges: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_HIGH_SCHOOLS':
            return {
                ...state,
                highSchools: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_HIGH_SCHOOLS_SUCCESS':
            return {
                ...state,
                highSchools: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_HIGH_SCHOOLS_FAILURE':
            return {
                ...state,
                highSchools: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_CREATE_PLAYS':
            return {
                ...state,
                playerCreatedPlays: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_CREATE_PLAYS_SUCCESS':
            return {
                ...state,
                playerCreatedPlays: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_CREATE_PLAYS_FAILURE':
            return {
                ...state,
                playerCreatedPlays: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS':
            return {
                ...state,
                paidHitClubs: {
                    loading: true,
                    data: [],
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS_SUCCESS':
            return {
                ...state,
                paidHitClubs: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case 'HOMEPAGE_CONTENT:GET_PAID_HIT_CLUBS_FAILURE':
            return {
                ...state,
                paidHitClubs: {
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };

        default:
            return state;
    }
}

export default app;
